import { render, staticRenderFns } from "./right1.vue?vue&type=template&id=17a806ce&scoped=true"
import script from "./right1.vue?vue&type=script&lang=js"
export * from "./right1.vue?vue&type=script&lang=js"
import style0 from "./right1.vue?vue&type=style&index=0&id=17a806ce&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17a806ce",
  null
  
)

export default component.exports